import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import { downloadLink } from '../../helpers/constFIles';
import { Grid, MenuItem, TextField, Box, Button, Typography } from '@mui/material';
import { URLS } from "../../helpers/URLS";
import useAxios from "../../helpers/Hooks/useAxios";
import ToolTip from '../../Tolltip';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import '../../assets/scss/tables.scss';

const AddCandidate = (props) => {

    const { show, onHide, reloadContent, selectedCandidateForEdit } = props;

    const [panErrMsg, setPanErrMsg] = useState(false);

    const [aadharErrMst, setAadharErrMsg] = useState(false);

    const { fetchData } = useAxios();

    const [jobs, setJobs] = useState([]);

    const [data, setData] = useState({
        candidateID: "",
        skills: '',
        jobID: '',
        name: '',
        email: '',
        phone: '',
        resumeUrl: '',
        experience: '',
        PAN: '',
        AADHAR: '',
        currentCTC: '',
        expectedCTC: '',
        noticePeroid: '',
        willJoinEarly: '',
        status: "",
        comments: []
    })

    useEffect(() => {
        GetJobJds()
    }, [])

    useEffect(() => {
        if (selectedCandidateForEdit && selectedCandidateForEdit._id) {
            setCandidateIfItHasForEdit(selectedCandidateForEdit)
        } else {
            resetModel();
        }
    }, [selectedCandidateForEdit])

    const GetJobJds = async () => {
        const resp = await fetchData({ url: URLS.getJobs, method: 'get' })
        const mapData = resp.data.map(x => { return { ...x, label: x.jobTitle } })
        if (mapData.length) {
            setData({
                ...data,
                jobID: mapData[0].jobID
            })
        }
        setJobs(mapData)
    }

    const setCandidateIfItHasForEdit = (candi) => {
        setData({
            candidateID: candi.candidateID,
            jobTitle: '',
            experienceFrom: '',
            experienceTo: '',
            skills: candi.skills,
            requirements: '',
            jobID: candi.jobID,
            name: candi.name,
            email: candi.email,
            phone: candi.phone,
            resumeUrl: candi.resumeUrl,
            experience: candi.experience,
            PAN: candi.PAN,
            AADHAR: candi.AADHAR,
            currentCTC: candi.currentCTC,
            expectedCTC: candi.expectedCTC,
            noticePeroid: candi.noticePeroid,
            willJoinEarly: candi.willJoinEarly,
            employeeID: '',
        })
    }

    const handlePAN = (e) => {
        var regex = /[A-Z,a-z]{5}[0-9]{4}[A-Z,a-z]{1}$/;
        if (regex.test(e.target.value) || e.target.value.length === 0) {
            setPanErrMsg(false);
        }
        else {
            setPanErrMsg(true);
        }
    }

    const handleAADHAR = (e) => {
        if (e.target.value.length === 12 || e.target.value.length === 0) {
            setAadharErrMsg(false);
        }
        else {
            setAadharErrMsg(true);
        }
    }

    const handleError = (e) => {
        if (e.target.name === "phone") {
            e.target.value = e.target.value.replace(/[^0-9]/g, "");
            return true;
        }
        if (e.target.name === 'AADHAR') {
            e.target.value = e.target.value.replace(/[^0-9]/g, "");
            handleAADHAR(e)
        }

        if (e.target.name === "PAN") {
            e.target.value = e.target.value.toUpperCase();
            handlePAN(e);
            return true;
        }
    }

    const handleOnChange = (e) => {
        handleError(e);
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    const onFileUpload = async (event) => {
        const formData = new FormData();
        formData.append(
            "resume",
            event.target.files[0],
            event.target.files[0].name
        );
        const resp = await fetchData({ url: URLS.resumeUpload, method: 'post', body: formData })
        if (resp.status === 200) {
            if (resp.data && resp.data.resumedata && resp.data.resumedata.email && resp.data.resumedata.name) {
                setData({
                    ...data,
                    ["resumeUrl"]: resp.data.filename,
                    ["email"]: resp.data.resumedata.email,
                    ["name"]: resp.data.resumedata.name
                })
            } else {
                setData({
                    ...data,
                    ["resumeUrl"]: resp.data.filename
                })
            }
            toast.success(resp.message);
        }
        else {
            toast.error(resp.message, 'error')
        }
    };

    const handleChangeProfiler = (value) => {
        setData({
            ...data,
            jobID: value.jobID
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {};
        if (data.candidateID) {
            for (const [key, value] of Object.entries(data)) {
                payload[key] = value;
            }
        }
        else {
            for (const [key, value] of Object.entries(data)) {
                if (key !== "_id") {
                    payload[key] = value;
                }
            }
        }
        const { status, message } = await fetchData({ url: URLS.addCandidate, method: 'post', body: payload })
        if (status === 200) {
            toast.success(message);
            resetModel();
            reloadContent();
            onHide(false);
        }
        else {
            toast.error(message, 'error')
        }
    }

    const resetModel = () => {
        setData({
            candidateID: "",
            jobTitle: '',
            experienceFrom: '',
            experienceTo: '',
            skills: '',
            requirements: '',
            jobID: jobs.length ? jobs[0]._id : "",
            name: '',
            email: '',
            phone: '',
            resumeUrl: '',
            experience: '',
            PAN: '',
            AADHAR: '',
            currentCTC: '',
            expectedCTC: '',
            noticePeroid: '',
            willJoinEarly: '',
            employeeID: '',
        })
    }

    return (
        <>
            <Modal size="lg" show={show} onHide={() => { onHide(false) }} backdrop="static" className="wh-modal">
                <Box component={'form'} onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>{data.candidateID ? 'Update' : 'Add'} Candidate</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <h6 className="wh-section-title" style={{ marginTop: 0 }}>
                            <WorkOutlineOutlinedIcon />Role
                        </h6>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField fullWidth label="Profiler" required size="small" select value={data.jobID}>
                                    {jobs.map((option) => (
                                        <MenuItem key={option.jobID} value={option.jobID} onClick={() => handleChangeProfiler(option)}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                        </Grid>

                        <h6 className="wh-section-title"><PersonOutlineOutlinedIcon />Candidate</h6>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <TextField fullWidth label="Name" value={data.name} onChange={handleOnChange} name={'name'} required size="small" />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField type={"email"} onChange={handleOnChange} value={data.email} fullWidth label="Email" name={'email'} required size="small" />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField required onChange={handleOnChange} value={data.phone} fullWidth label="Phone" name={'phone'} size="small" inputProps={{ maxLength: 10 }} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField fullWidth onChange={handleOnChange} value={data.experience} label="Experience" size="small" name='experience' />
                            </Grid>
                        </Grid>

                        <h6 className="wh-section-title"><BadgeOutlinedIcon />Identity</h6>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <TextField fullWidth label="PAN" error={panErrMsg}
                                    helperText={panErrMsg ? 'PAN number is not valid' : ' '}
                                    inputProps={{ maxLength: 10 }}
                                    size="small" value={data.PAN} onChange={handleOnChange} name="PAN"
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField fullWidth label="AADHAR" name={'AADHAR'} error={aadharErrMst}
                                    inputProps={{ maxLength: 12 }} value={data.AADHAR} onChange={handleOnChange}
                                    helperText={aadharErrMst ? 'Aadhar number is not valid' : ' '}
                                    size="small" />
                            </Grid>
                            {!(data.AADHAR.length > 0 || data.PAN.length > 0) &&
                                <Grid item xs={12}>
                                    <Typography variant='body2' color={'#d32f2f'}>
                                        Enter either a PAN or an Aadhar number.
                                    </Typography>
                                </Grid>
                            }
                        </Grid>

                        <h6 className="wh-section-title"><PaidOutlinedIcon />Compensation and notice</h6>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <TextField fullWidth label="Current CTC" onChange={handleOnChange} value={data.currentCTC} name={'currentCTC'} size="small" />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField fullWidth label="Expected CTC" onChange={handleOnChange} value={data.expectedCTC} name={'expectedCTC'} size="small" />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField fullWidth label="Notice Period (Days)" value={data.noticePeroid} onChange={handleOnChange} name={'noticePeroid'} size="small" />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField fullWidth label="Will join early (Days)" value={data.willJoinEarly} onChange={handleOnChange} name={'willJoinEarly'} size="small" />
                            </Grid>
                        </Grid>

                        <h6 className="wh-section-title"><PsychologyOutlinedIcon />Skills</h6>
                        <TextField fullWidth multiline rows={3} label="Skills"
                            placeholder="React, TypeScript, Node.js"
                            helperText="Separate each skill with a comma."
                            value={data.skills} onChange={handleOnChange} name={'skills'} size="small" required />

                        <h6 className="wh-section-title"><DescriptionOutlinedIcon />Resume</h6>
                        <label className="wh-upload" htmlFor="file_upload">
                            <CloudUploadOutlinedIcon />
                            <h6>Choose a CV to upload</h6>
                            <p>PDF or DOCX. Name and email are read from it where possible.</p>
                            <input onChange={onFileUpload} accept=".pdf,.docx" type="file"
                                name="resume" id="file_upload" />
                        </label>

                        {data.resumeUrl && (
                            <div className="wh-upload-file">
                                <DescriptionOutlinedIcon />
                                <a href={downloadLink + data.resumeUrl} target="_blank" rel="noopener noreferrer">
                                    {data.resumeUrl}
                                </a>
                                <ToolTip title="Remove resume" placement="top">
                                    <CloseOutlinedIcon className="wh-upload-remove" onClick={() => setData({
                                        ...data,
                                        resumeUrl: ''
                                    })} />
                                </ToolTip>
                            </div>
                        )}

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="contained" color='inherit' onClick={() => { onHide(false) }}>
                            Close
                        </Button>
                        <Button type="submit" variant="contained"
                            disabled={aadharErrMst || panErrMsg || !(data.AADHAR.length === 12 || data.PAN.length === 10) ? true : false} >
                            {data.candidateID ? 'Update' : 'Add'}
                        </Button>
                    </Modal.Footer>
                </Box>
            </Modal>
        </>
    )
}

export default AddCandidate;